export default __webpack_public_path__ + "d9062483cecdfac8d36d70e6dc0109fd.png";